var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { useLanguage } from '@base/LanguageProvider';
import { EntityPermissionsType, TagType, } from '@common/api';
import Manager from '@shared/modal/Manager';
import { ContextMenu } from '@shared/contextmenu';
import ShareModal from '@shared/finder/modals/ShareModal';
import DeleteTagModal from '@shared/finder/modals/DeleteTag';
import * as FarseerIcons from '@shared/icons/icons';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { useTagActions } from '@data/tag/tagActions';
import { TagQueryKeys } from '@data/tag/types';
import { TableTagBadge, TEGroupItem, TEGroupItemName, TETagInput } from '@styled/TagEditor';
import { getGenericUniqueTagName } from './menuItems';
import { calculateTagPerms, canCreateTagChildren } from './permissions';
export function TagGroup(_a) {
    var e_1, _b;
    var groupId = _a.groupId, selectedGroupId = _a.selectedGroupId, tagsByParentId = _a.tagsByParentId, tagByLowercaseName = _a.tagByLowercaseName, selectGroupHandler = _a.selectGroupHandler, selectTableHandler = _a.selectTableHandler, expandGroupHandler = _a.expandGroupHandler, filterByType = _a.filterByType, expanded = _a.expanded, allGroups = _a.allGroups, changeTagParent = _a.changeTagParent, tagActionsMap = _a.tagActionsMap, user = _a.user, _c = _a.allowGroupActions, allowGroupActions = _c === void 0 ? true : _c, _d = _a.depth, depth = _d === void 0 ? 0 : _d;
    var L = useLanguage().L;
    var children = tagsByParentId["".concat(groupId)];
    var groups = [];
    var showGroups = filterByType === undefined ? true : filterByType.includes(TagType.Group);
    var tables = [];
    var showTables = filterByType === undefined ? true : filterByType.includes(TagType.Table);
    var accounts = [];
    var showAccounts = filterByType === undefined ? true : filterByType.includes(TagType.Account);
    var tagClassActions = user === null || user === void 0 ? void 0 : user.classActions.tagClassActions;
    if (children && (children === null || children === void 0 ? void 0 : children.length) > 0) {
        try {
            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                var ch = children_1_1.value;
                switch (ch.type) {
                    case TagType.Group:
                        groups.push(ch);
                        break;
                    case TagType.Table:
                        tables.push(ch);
                        break;
                    case TagType.Account:
                        accounts.push(ch);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return (React.createElement("div", { style: { paddingLeft: depth ? 20 : 0 } },
            showGroups &&
                groups.map(function (ch) {
                    var isExpanded = expanded.includes(ch.id);
                    var isActive = ch.id === selectedGroupId;
                    return (React.createElement("div", { key: "group-".concat(ch.id) },
                        React.createElement(TagGroupItem, { groupTag: ch, isExpanded: isExpanded, isActive: isActive, selectGroupHandler: selectGroupHandler, expandGroupHandler: expandGroupHandler, tagByLowercaseName: tagByLowercaseName, expanded: expanded, tagClassActions: tagClassActions, tagActionsMap: tagActionsMap, allGroups: allGroups, changeTagParent: changeTagParent, allowGroupActions: allowGroupActions }),
                        isExpanded && (React.createElement(TagGroup, { groupId: ch.id, selectedGroupId: selectedGroupId, tagsByParentId: tagsByParentId, tagByLowercaseName: tagByLowercaseName, depth: depth + 1, selectGroupHandler: selectGroupHandler, selectTableHandler: selectTableHandler, expandGroupHandler: expandGroupHandler, filterByType: filterByType, expanded: expanded, tagActionsMap: tagActionsMap, allGroups: allGroups, changeTagParent: changeTagParent, user: user, allowGroupActions: allowGroupActions }))));
                }),
            showTables &&
                tables.map(function (ch) {
                    return (React.createElement(TableTagBadge, { key: "table-".concat(ch.id), onClick: function () { return selectTableHandler(ch.id, groupId); } }, ch.name));
                }),
            showAccounts && accounts.length > 0 && (React.createElement(TableTagBadge, { className: "acc", key: "accounts", onClick: function () { return selectTableHandler(0, groupId); } }, L('Variables')))));
    }
    else {
        return null;
    }
}
function TagGroupItem(_a) {
    var _this = this;
    var groupTag = _a.groupTag, isExpanded = _a.isExpanded, isActive = _a.isActive, selectGroupHandler = _a.selectGroupHandler, expandGroupHandler = _a.expandGroupHandler, tagByLowercaseName = _a.tagByLowercaseName, expanded = _a.expanded, allGroups = _a.allGroups, changeTagParent = _a.changeTagParent, tagClassActions = _a.tagClassActions, tagActionsMap = _a.tagActionsMap, allowGroupActions = _a.allowGroupActions;
    var L = useLanguage().L;
    var queryClient = useQueryClient();
    var _b = useTagActions(), createTag = _b.createTag, editTag = _b.editTag;
    var menuTriggerRef = useRef(null);
    var canCreateGroup = canCreateTagChildren(tagClassActions, tagActionsMap, groupTag, true);
    var _c = calculateTagPerms(tagClassActions, tagActionsMap, groupTag), canEdit = _c.canEdit, canDelete = _c.canDelete;
    var _d = __read(useState(false), 2), isEditing = _d[0], setIsEditing = _d[1];
    var _e = __read(useState(''), 2), tagName = _e[0], setTagName = _e[1];
    var cancelEditing = function () {
        setIsEditing(false);
    };
    var wrapRef = useRef(null);
    useOutsideClick(wrapRef, cancelEditing, !isEditing);
    var addGroup = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.stopPropagation();
                    return [4 /*yield*/, createTag({
                            name: getGenericUniqueTagName(tagByLowercaseName, 'Group'),
                            type: TagType.Group,
                            ParentId: groupTag.id,
                        })];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                    // expand parent if not expanded already
                    if (!expanded.includes(groupTag.id)) {
                        expandGroupHandler(groupTag.id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var keyDownHandler = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.key === 'Enter')) return [3 /*break*/, 2];
                    return [4 /*yield*/, editTag(__assign(__assign({}, groupTag), { name: tagName })).catch(function (e) {
                            toast.error('Group ' + e.message);
                            return;
                        })];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                    setTagName('');
                    setIsEditing(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var moveToOptions = useMemo(function () {
        var arr = [
            {
                actionName: 'Root',
                isDisabled: !canEdit,
                action: function () { return changeTagParent(groupTag === null || groupTag === void 0 ? void 0 : groupTag.id, null); },
            },
        ];
        allGroups.forEach(function (group) {
            // to do!!!
            var notChild = group.id !== groupTag.id && group.ParentId !== groupTag.id && groupTag.ParentId !== group.id;
            if (notChild && canEdit) {
                var targetParentTagPerms = calculateTagPerms(tagClassActions, tagActionsMap, group);
                if (targetParentTagPerms.canEdit) {
                    arr.push({
                        actionName: group.name,
                        isDisabled: !canEdit,
                        action: function () { return changeTagParent(groupTag.id, group.id); },
                    });
                }
            }
        });
        return arr;
    }, [allGroups]);
    return (React.createElement(TEGroupItem, { "$isActive": isActive, ref: wrapRef },
        React.createElement("div", { className: "expand-btn", onClick: function () { return expandGroupHandler(groupTag.id); } }, isExpanded ? React.createElement(FaChevronDown, null) : React.createElement(FaChevronRight, null)),
        isEditing ? (React.createElement(TETagInput, { autoComplete: "on", type: "text", value: tagName, name: "tag", onChange: function (e) { return setTagName(e.target.value); }, onKeyDown: keyDownHandler })) : (React.createElement(TEGroupItemName, { onClick: function () { return selectGroupHandler(groupTag.id); } }, groupTag.name)),
        allowGroupActions && (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: menuTriggerRef, className: "menu-btn" },
                React.createElement(FarseerIcons.ThreeDots, null)),
            React.createElement(ContextMenu, { items: [
                    {
                        icon: FarseerIcons.Plus,
                        actionName: L('New Group'),
                        isDisabled: !canCreateGroup,
                        creative: true,
                        action: addGroup,
                    },
                    { spacer: true },
                    {
                        icon: FarseerIcons.Edit,
                        actionName: L('Rename'),
                        isDisabled: !canEdit,
                        action: function () {
                            setTagName(groupTag.name);
                            setIsEditing(true);
                        },
                    },
                    {
                        icon: FarseerIcons.Share,
                        actionName: L('Share'),
                        isDisabled: !canEdit,
                        action: function () {
                            Manager.renderModal(React.createElement(ShareModal, { targetId: groupTag.id, entity: EntityPermissionsType.Tag }));
                        },
                    },
                    {
                        icon: FarseerIcons.ArrowRight,
                        actionName: L('Move to'),
                        isDisabled: !canEdit,
                        items: moveToOptions,
                    },
                    { spacer: true },
                    {
                        icon: FarseerIcons.Delete,
                        actionName: L('Delete Group'),
                        isDisabled: !canDelete,
                        destructive: true,
                        action: function () {
                            Manager.renderModal(React.createElement(DeleteTagModal, { target: groupTag, deleteType: "tag" }));
                        },
                    },
                ], triggerRefs: [{ ref: menuTriggerRef, trigger: 'click' }] })))));
}
